import { Card, CommonProp, CompactHeader, FirstTier, PageWrapper, SecondTier } from '@acin/ui-core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { REGULATION_TABS } from '../../../helpers/utils';
import { getRegulationDetailPath } from '../../../routes/routes';
import { DocumentsModal } from '../../Documents/components/DocumentsModal';
import { DocumentSwitcher } from '../../Documents/components/DocumentSwitcher';
import { MapControlsProvider } from '../../MapControlsProvider';
import { PageLayout } from '../../PageLayout';
import { RegTextProvider } from '../../RegTextProvider';
import { useRegulationDetail } from '../../RegulationDetailProvider';
import { useRegulation } from '../../RegulationProvider';
import { ReviewObligationsProvider } from '../../ReviewObligationsProvider';
import { MapControls } from './MapControls';
import * as SC from './RegulationDetail.styled';
import { ReviewObligations } from './ReviewObligations';

export interface ConnectMenuProps extends CommonProp {
  className?: string;
}

const TABS = Object.values(REGULATION_TABS);

export const RegulationDetail: React.FC<ConnectMenuProps> = (props) => {
  const { className } = props;
  const { regulationId } = useRegulationDetail();
  const { activeRegulationTabId: tabId } = useRegulation();
  const history = useHistory();

  const handleTabClick = (newTabId: string) => {
    history.push(getRegulationDetailPath(regulationId, newTabId));
  };

  const renderContent = () => {
    switch (tabId) {
      case REGULATION_TABS.SCOPING.id:
        return <Card>Scoping for {regulationId}</Card>;
      case REGULATION_TABS.MAP.id:
        return (
          <MapControlsProvider>
            <MapControls />
          </MapControlsProvider>
        );
      default:
        return (
          <ReviewObligationsProvider>
            <RegTextProvider>
              <ReviewObligations />
            </RegTextProvider>
          </ReviewObligationsProvider>
        );
    }
  };

  return (
    <SC.RegulationDetail data-testid={`regulation-detail-${regulationId}`} className={className}>
      <PageLayout>
        <PageWrapper
          hasTabs
          header={
            <CompactHeader
              firstTier={<FirstTier title="Regulation Detail" variation="parent" />}
              secondTier={
                <SecondTier
                  activeTab={tabId}
                  tabs={TABS}
                  onTabClick={handleTabClick}
                  rightArea={<DocumentSwitcher regulationId={regulationId} />}
                />
              }
            />
          }
        >
          <SC.ContentLayout headerHeight={162}>{renderContent()}</SC.ContentLayout>
        </PageWrapper>
      </PageLayout>
      <DocumentsModal regulationId={regulationId} />
    </SC.RegulationDetail>
  );
};
